import React, {useState} from 'react';
import { axiosImageAuthFetch } from '../../../helpers/apiActions/authFetch';
import styles from './editAndAddSupplier.module.css';
import { API_BASE_URL } from '../../../constants';
import Loader from '../../loader';

export function EditSupplierForm({ supplier }) {
    const [name, setName] = useState(supplier.attributes.name);
    const [logo, setLogo] = useState(null);
    const [telephone, setTelephone] = useState(supplier.attributes.contact_info?.telephone || '');
    const [email, setEmail] = useState(supplier.attributes.contact_info?.email || '');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogoChange = (e) => {
        setLogo(e.target.files[0]);
    };

    const handleSave = async () => {
        setIsLoading(true);

        const data = {
            name,
            contact_info: {
                telephone,
                email,
            },
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        if (logo) {
            formData.append('files.logo', logo);
        }

        try {
            const response = await axiosImageAuthFetch(`${API_BASE_URL}/suppliers/${supplier.id}`, formData, 'PUT');
            console.log(response);
            alert('Oppdatering fullført!')
            setIsLoading(false);
            window.location.reload();
            // Oppdater UI eller gi tilbakemelding til brukeren
        } catch (error) {
            console.error(error);
            // Håndter feil
        }
    };
    
    if(isLoading) {
        return (<Loader />)
    }

    return (
        <div className={styles.formContainer}>
            <h2>Rediger {supplier.attributes.name}</h2>
            <form>
                <div className={styles.line}>
                    <label>Navn</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className={styles.line}>
                    <label>Logo</label>
                    <input type="file" onChange={handleLogoChange} />
                </div>
                <div className={styles.line}>
                    <label>Telefon</label>
                    <input type="text" value={telephone} onChange={(e) => setTelephone(e.target.value)} />
                </div>
                <div className={styles.line}>
                    <label>Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className={styles.button} onClick={handleSave}>Lagre</div>
            </form>
        </div>
    );
}

export function AddSupplierForm() {
    const [name, setName] = useState('');
    const [logo, setLogo] = useState(null);
    const [telephone, setTelephone] = useState('');
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogoChange = (e) => {
        setLogo(e.target.files[0]);
    };

    const handleAdd = async () => {
        setIsLoading(true);
        const data = {
            name,
            contact_info: {
                telephone,
                email,
            },
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        if (logo) {
            formData.append('files.logo', logo);
        }

        try {
            const response = await axiosImageAuthFetch(`${API_BASE_URL}/suppliers`, formData);
            console.log(response);
            setIsLoading(false);
            alert("Leverandør opprettet!")
            window.location.reload();
            // Oppdater UI eller gi tilbakemelding til brukeren
        } catch (error) {
            console.error(error);
            // Håndter feil
        }
    };

    if(isLoading) {
        return (<Loader />)
    }

    return (
        <div className={styles.formContainer}>
            <h2>Legg til leverandør</h2>
            <form>
                <div className={styles.line}>
                    <label>Navn</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className={styles.line}>
                    <label>Logo</label>
                    <input type="file" onChange={handleLogoChange} />
                </div>
                <div className={styles.line}>
                    <label>Telefon</label>
                    <input type="text" value={telephone} onChange={(e) => setTelephone(e.target.value)} />
                </div>
                <div className={styles.line}>
                    <label>Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className={styles.button} onClick={handleAdd}>Legg til</div>
            </form>
        </div>
    );
}